export default __webpack_public_path__ + "static/media/speech-bubble-message.7b8776e1.svg";